import { Controller } from "@hotwired/stimulus";

// The separate-family form posts with target="_blank", so the separation
// itself runs in the new tab while this (original) tab stays put. Once the
// form is submitted, give the new tab a moment to finish, then reload this
// page so the family renders without the separated profile.
export default class extends Controller {
  static values = { delay: { type: Number, default: 2000 } }

  schedule() {
    if (this.timeout) { return }
    this.timeout = setTimeout(() => {
      window.location.reload()
    }, this.delayValue)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
